import React, { useState } from "react";
import fire from "../../config/Fire";
import API from "../../utils/API";

function SignupCard() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    telephone: "",
    residentState: ""
  });

  const [showOptions, setShowOptions] = useState(true);
  const [agentSignup, setAgentSignup] = useState(false);
  const [clientSignup, setClientSignup] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const checkCredentials = (uid) => {
    console.log(uid + " has logged in");

    let client = false;
    let agent = false;
    let admin = false;
    console.log(client, agent, admin);

    API.findClientLogin(uid)
      .then((res) => {
        console.log(res);
        if (res.data.length > 0) {
          console.log("This is a client login");
          client = true;
          document.location.href = "/client";
        } else {
          API.findAgentLogin(uid)
            .then((res) => {
              if (res.data.length > 0) {
                console.log("This is an agent login");
                agent = true;
                document.location.href = "/agent";
              } else {
                API.findAdminLogin(uid)
                  .then((res) => {
                    if (res.data.length > 0) {
                      console.log("This is an admin login");
                      admin = true;
                      document.location.href = "/admin";
                    }
                  })
                  .catch((_err) => console.log("This is not a proper login"));
              }
            })
            .catch((_err) => console.log("Type of user not found"));
        }
      })
      .catch((_err) => console.log("This is not a proper login"));
  };

  const createAgentAccount = (e) => {
    e.preventDefault();
    if (formData.password === formData.confirmPassword) {
      alert("Creating Account...");
      console.log(formData);
      console.log("no code here yet");
      fire
        .auth()
        .createUserWithEmailAndPassword(formData.email, formData.password)
        .then((data) => {
          console.log("Successfully created user");
          console.log(data);
          API.saveAgent({
            uid: data.user.uid,
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: data.user.email,
            telephone: formData.telephone,
            servicer: formData.clientServicer,
            residentState: formData.residentState
          });

          fire
            .auth()
            .signInWithEmailAndPassword(formData.email, formData.password)
            .then((res) => {
              console.log(res.user.uid);
              console.log(res);
              checkCredentials(res.user.uid);
              document.cookie = "fawnuid=" + res.user.uid;
              document.location.href = "/agent";
            })
            .catch((error) => {
              console.log(error);
            });
        });
    } else {
      alert("Passwords don't match!");
    }
  };

  const createClientAccount = (e) => {
    e.preventDefault();
    if (formData.password === formData.confirmPassword) {
      alert("Creating Account...");
      console.log(formData);
      fire
        .auth()
        .createUserWithEmailAndPassword(formData.email, formData.password)
        .then((data) => {
          console.log("Successfully created user");
          console.log(data);
          alert("User: " + formData.firstName + " " + formData.lastName + " was created!");

          API.saveClient({
            uid: data.user.uid,
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: data.user.email,
            telephone: formData.telephone,
            servicer: formData.servicer
          });

          fire
            .auth()
            .signInWithEmailAndPassword(formData.email, formData.password)
            .then((res) => {
              console.log(res.user.uid);
              console.log(res);
              checkCredentials(res.user.uid);
              document.cookie = "fawnuid=" + res.user.uid;
              document.location.href = "/client";
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
          alert("Error: User not created!");
        });
    }
  };

  const toggleOptions = (_e) => {
    if (showOptions === true) {
      setAgentSignup(false);
      setClientSignup(false);
      setShowOptions(false);
    } else {
      setAgentSignup(false);
      setClientSignup(false);
      setShowOptions(true);
    }
  };

  const toggleAgentSignup = (_e) => {
    if (agentSignup === true) {
      setAgentSignup(false);
      setShowOptions(true);
    } else {
      setAgentSignup(true);
      setClientSignup(false);
      setShowOptions(false);
    }
  };

  const toggleClientSignup = (_e) => {
    if (clientSignup === true) {
      setClientSignup(false);
      setShowOptions(true);
    } else {
      setAgentSignup(false);
      setClientSignup(true);
      setShowOptions(false);
    }
  };

  return (
    <div
      className="opacity-60"
      style={{
        backgroundColor: "rgba(0,0,0,0.75)",
        width: "100%",
        color: "black",
        borderRadius: "5px"
      }}
    >
      <div className="card-body" style={{ backgroundColor: "transparent" }}>
        <div className="row">
          {showOptions ? (
            <div className="col-12" style={{ textAlign: "center" }}>
              <h3 style={{ color: "white" }}>Are you a Client or Agent?</h3>
              <button
                style={{ textAlign: "center", margin: "10px", width: "150px" }}
                onClick={toggleClientSignup}
                disabled={false}
                className="btn btn-lg btn-light"
              >
                <strong>Client</strong>
              </button>
              <button
                style={{ textAlign: "center", margin: "10px", width: "150px" }}
                onClick={toggleAgentSignup}
                className="btn btn-lg btn-light"
              >
                <strong>Agent </strong>
              </button>
            </div>
          ) : null}

          {agentSignup ? (
            <div className="col-12" style={{ textAlign: "center" }}>
              <h3 style={{ color: "white" }}>Agent Sign Up</h3>
              <form style={{ color: "white", padding: "5%" }}>
                <label className="form-group">
                  <strong>Email</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.email}
                  name="email"
                  onChange={handleInputChange}
                />
                <br />

                <label>
                  <strong>Password</strong>
                </label>
                <br />
                <input
                  type="password"
                  value={formData.password}
                  name="password"
                  onChange={handleInputChange}
                />
                <br />

                <label>
                  <strong>Confirm Password</strong>
                </label>
                <br />
                <input
                  type="password"
                  value={formData.confirmPassword}
                  name="confirmPassword"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>First Name</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.firstName}
                  name="firstName"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>Last Name</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.lastName}
                  name="lastName"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>Telephone</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.telephone}
                  name="telephone"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>Resident State</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.residentState}
                  name="residentState"
                  onChange={handleInputChange}
                />
                <br />
              </form>
              <br />
              <br />
              <button
                style={{ textAlign: "center", margin: "10px", width: "150px" }}
                onClick={createAgentAccount}
                className="btn btn-lg btn-light"
              >
                <strong>Submit</strong>
              </button>
              <button
                style={{ textAlign: "center", margin: "10px", width: "150px" }}
                onClick={toggleOptions}
                className="btn btn-lg btn-light"
              >
                <strong>Quit</strong>
              </button>
            </div>
          ) : null}

          {clientSignup ? (
            <div className="col-12" style={{ textAlign: "center", padding: "5%" }}>
              <h3 style={{ color: "white" }}>Client Sign Up</h3>
              <form style={{ color: "white" }}>
                <label className="form-group">
                  <strong>Email</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.email}
                  name="email"
                  onChange={handleInputChange}
                />
                <br />

                <label>
                  <strong>Password</strong>
                </label>
                <br />
                <input
                  type="password"
                  value={formData.password}
                  name="password"
                  onChange={handleInputChange}
                />
                <br />

                <label>
                  <strong>Confirm Password</strong>
                </label>
                <br />
                <input
                  type="password"
                  value={formData.confirmPassword}
                  name="confirmPassword"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>First Name</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.firstName}
                  name="firstName"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>Last Name</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.lastName}
                  name="lastName"
                  onChange={handleInputChange}
                />
                <br />

                <label className="form-group">
                  <strong>Telephone</strong>
                </label>
                <br />
                <input
                  type="text"
                  className="form-group"
                  value={formData.telephone}
                  name="telephone"
                  onChange={handleInputChange}
                />
                <br />
              </form>
              <br />
              <br />
              <button
                style={{ textAlign: "center", margin: "10px", width: "150px" }}
                onClick={createClientAccount}
                className="btn btn-lg btn-light"
              >
                <strong>Submit</strong>
              </button>
              <button
                style={{ textAlign: "center", margin: "10px", width: "150px" }}
                onClick={toggleOptions}
                className="btn btn-lg btn-light"
              >
                <strong>Quit</strong>
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default SignupCard;
